import { API_FEES_CONFIGURABLES } from "../../utils/apis";
import { getRegister } from "../../utils/helpers";
import { URL_FEES_CONFIGURABLES } from "../../utils/urls";

export const useFeesConfigurablesForm = () => {
  const sections = [
    {
      title: "Configurable Details",
      fields: [
        {
          field_name: "name",
          type: "Name",
          label: "Fees",
          props: { required: true },
        },
        {
          field_name: "amount",
          type: "number",
          label: "Amount",
          props: { required: true },
        },
        {
          field_name: "description",
          type: "textarea",
          label: "Description",
          props: { required: true },
        },
      ],
    },
  ];

  const redirect = getRegister(URL_FEES_CONFIGURABLES);

  return {
    sections,
    redirect,
  };
};

export function submitFeesConfigurables(payload: any, id: string) {
  //  on update
  if (id) {
    return {
      id,
      api: API_FEES_CONFIGURABLES,
      params: payload,
    };
  }
  // on create
  return {
    api: API_FEES_CONFIGURABLES,
    params: payload,
  };
}
